(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-total-price"] && !Shopify.designMode) return;
  try {
    class DynamicTotalPrice extends HTMLElement {
  connectedCallback() {
    this.basePrice = 0;
    this.paintSetPrice = 0;
    this.paintSetAdded = false;
    this.petAddonPrice = 0;

    this.parseCurrentPrice();

    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (e) => this.handleVariantUpdate(e));
    }

    document.addEventListener('paint-set:change', (e) => this.handlePaintSetChange(e));
    document.addEventListener('pet-addon:change', (e) => this.handlePetAddonChange(e));
  }

  parseCurrentPrice() {
    const priceElement = this.querySelector('.dynamic-total-price__amount');
    if (!priceElement) return;

    const priceText = priceElement.textContent.trim();
    const numericString = priceText.replace(/[^\d,\.]/g, '').replace(',', '.');
    this.basePrice = Math.round(parseFloat(numericString) * 100);
  }

  handleVariantUpdate(event) {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    const newPriceElement = html.querySelector('dynamic-total-price');
    if (!newPriceElement) return;

    this.innerHTML = newPriceElement.innerHTML;
    this.parseCurrentPrice();

    if (this.paintSetAdded || this.petAddonPrice > 0) {
      this.updateDisplayedPrice();
    }
  }

  handlePaintSetChange(event) {
    this.paintSetAdded = event.detail && event.detail.added;
    if (event.detail && event.detail.price) {
      this.paintSetPrice = event.detail.price;
    }
    this.updateDisplayedPrice();
  }

  handlePetAddonChange(event) {
    if (event.detail && typeof event.detail.totalPrice !== 'undefined') {
      this.petAddonPrice = event.detail.totalPrice;
    }
    this.updateDisplayedPrice();
  }

  updateDisplayedPrice() {
    const priceElement = this.querySelector('.dynamic-total-price__amount');
    if (!priceElement) return;

    let totalPrice = this.basePrice;
    if (this.paintSetAdded && this.paintSetPrice > 0) {
      totalPrice += this.paintSetPrice;
    }
    if (this.petAddonPrice > 0) {
      totalPrice += this.petAddonPrice;
    }

    const euros = (totalPrice / 100).toFixed(2).replace('.', ',');
    priceElement.textContent = String.fromCharCode(8364) + euros;
  }
}

if (!customElements.get('dynamic-total-price')) {
  customElements.define('dynamic-total-price', DynamicTotalPrice);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paint-set-addon"] && !Shopify.designMode) return;
  try {
    class PaintSetAddon extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('.paint-set-addon__checkbox');
    this.paintSetPrice = parseInt(this.dataset.paintSetPrice, 10) || 0;
    this.paintSetVariantId = this.dataset.paintSetVariantId;

    if (this.checkbox) {
      this.checkbox.addEventListener('change', () => this.dispatchPriceChange());
    }

    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (e) => this.handleVariantChange(e));
    }

    document.addEventListener('cart:update', (e) => this.handleCartAdd(e));
  }

  handleVariantChange(event) {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    const newAddon = html.querySelector('paint-set-addon');
    if (newAddon) {
      const isHidden = newAddon.classList.contains('paint-set-addon--hidden');
      this.classList.toggle('paint-set-addon--hidden', isHidden);
      if (isHidden && this.checkbox && this.checkbox.checked) {
        this.checkbox.checked = false;
        this.dispatchPriceChange();
      }
    }
  }

  dispatchPriceChange() {
    document.dispatchEvent(new CustomEvent('paint-set:change', {
      bubbles: true,
      detail: {
        added: this.checkbox ? this.checkbox.checked : false,
        price: this.paintSetPrice
      }
    }));
  }

  handleCartAdd(event) {
    if (!this.checkbox || !this.checkbox.checked || !this.paintSetVariantId) return;
    if (event.detail && event.detail.data && event.detail.data.source === 'paint-set-addon') return;
    if (event.detail && event.detail.data && event.detail.data.didError) return;

    const formData = new FormData();
    formData.append('id', this.paintSetVariantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then((response) => {
      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'paint-set-addon' } }
        }));
        this.checkbox.checked = false;
        this.dispatchPriceChange();
      }
    }).catch((error) => {
      console.error('Error adding paint set:', error);
    });
  }
}

if (!customElements.get('paint-set-addon')) {
  customElements.define('paint-set-addon', PaintSetAddon);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pet-addon"] && !Shopify.designMode) return;
  try {
    class PetAddon extends HTMLElement {
  connectedCallback() {
    this.quantityInput = this.querySelector('.pet-addon__quantity-input');
    this.totalPriceEl = this.querySelector('.pet-addon__total-price');
    this.minusBtn = this.querySelector('.pet-addon__quantity-btn--minus');
    this.plusBtn = this.querySelector('.pet-addon__quantity-btn--plus');
    this.petPrice = parseInt(this.dataset.petPrice, 10) || 0;
    this.petVariantId = this.dataset.petVariantId;

    this.bindEvents();
    this.updateTotalPrice();
    this.dispatchPriceChange();

    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('variant:update', (e) => this.handleVariantChange(e));
    }

    document.addEventListener('cart:update', (e) => this.handleCartAdd(e));
  }

  bindEvents() {
    if (this.minusBtn) {
      this.minusBtn.addEventListener('click', () => this.decreaseQuantity());
    }
    if (this.plusBtn) {
      this.plusBtn.addEventListener('click', () => this.increaseQuantity());
    }
    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', () => this.onQuantityChange());
      this.quantityInput.addEventListener('input', () => this.onQuantityChange());
    }
  }

  getQuantity() {
    if (!this.quantityInput) return 0;
    const isHidden = this.classList.contains('pet-addon--hidden');
    if (isHidden) return 0;
    return Math.max(1, Math.min(10, parseInt(this.quantityInput.value, 10) || 1));
  }

  decreaseQuantity() {
    if (!this.quantityInput) return;
    const currentVal = parseInt(this.quantityInput.value, 10) || 1;
    const newVal = Math.max(1, currentVal - 1);
    this.quantityInput.value = newVal;
    this.onQuantityChange();
  }

  increaseQuantity() {
    if (!this.quantityInput) return;
    const currentVal = parseInt(this.quantityInput.value, 10) || 1;
    const newVal = Math.min(10, currentVal + 1);
    this.quantityInput.value = newVal;
    this.onQuantityChange();
  }

  onQuantityChange() {
    if (!this.quantityInput) return;
    let val = parseInt(this.quantityInput.value, 10) || 1;
    val = Math.max(1, Math.min(10, val));
    this.quantityInput.value = val;
    this.updateTotalPrice();
    this.dispatchPriceChange();
  }

  updateTotalPrice() {
    if (!this.totalPriceEl) return;
    const quantity = this.getQuantity();
    const total = this.petPrice * quantity;
    const euros = (total / 100).toFixed(2).replace('.', ',');
    this.totalPriceEl.textContent = '+' + String.fromCharCode(8364) + euros;
  }

  handleVariantChange(event) {
    const html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    const newAddon = html.querySelector('pet-addon');
    if (newAddon) {
      const isHidden = newAddon.classList.contains('pet-addon--hidden');
      const wasHidden = this.classList.contains('pet-addon--hidden');
      this.classList.toggle('pet-addon--hidden', isHidden);

      // Reset quantity when hiding or showing
      if (isHidden !== wasHidden) {
        if (this.quantityInput) {
          this.quantityInput.value = 1;
        }
        this.updateTotalPrice();
        this.dispatchPriceChange();
      }
    }
  }

  dispatchPriceChange() {
    const quantity = this.getQuantity();
    const isVisible = !this.classList.contains('pet-addon--hidden');

    document.dispatchEvent(new CustomEvent('pet-addon:change', {
      bubbles: true,
      detail: {
        quantity: isVisible ? quantity : 0,
        pricePerUnit: this.petPrice,
        totalPrice: isVisible ? this.petPrice * quantity : 0
      }
    }));
  }

  handleCartAdd(event) {
    if (!this.petVariantId) return;
    if (this.classList.contains('pet-addon--hidden')) return;
    if (event.detail && event.detail.data && event.detail.data.source === 'pet-addon') return;
    if (event.detail && event.detail.data && event.detail.data.didError) return;

    const quantity = this.getQuantity();
    if (quantity < 1) return;

    const formData = new FormData();
    formData.append('id', this.petVariantId);
    formData.append('quantity', quantity.toString());

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then((response) => {
      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'pet-addon' } }
        }));
        // Reset quantity after adding to cart
        if (this.quantityInput) {
          this.quantityInput.value = 1;
        }
        this.updateTotalPrice();
        this.dispatchPriceChange();
      }
    }).catch((error) => {
      console.error('Error adding pet to cart:', error);
    });
  }
}

if (!customElements.get('pet-addon')) {
  customElements.define('pet-addon', PetAddon);
}
  } catch(e) { console.error(e); }
})();

})();
